import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  border: 1px solid rgb(224, 224, 227);
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin: 0 16px 0 0;

  @media (orientation: landscape) {
    height: 36px;
    width: 36px;
  }
`;

const Icon = styled.div<{ active: boolean }>`
  background: ${(props) => (props.active ? 'rgb(33, 33, 36)' : 'transparent')};
  height: 40px;
  width: 40px;
  border-radius: 50%;

  @media (orientation: landscape) {
    height: 30px;
    width: 30px;
  }
`;

type Props = {
  active: boolean;
};

const RadioIcon = ({ active }: Props) => {
  return (
    <Wrapper>
      <Icon active={active} />
    </Wrapper>
  );
};

export default RadioIcon;
